import React from "react";
import TYPE from "../../../../../../../constant/TYPE";
import Button from "../../../../../../common/Button";

const Landscape = ( props ) => {

  return (
    <div className="keypad_gm num_symbol hide_tv hide_m">
      <div className="mid_area">
        <table className="key_tbl" summary="키패드">
          <tbody>
          <tr className="l_gray">
            <td><Button latex="\frac{}{}" cursor="<" onClick={ props.onEditableViewer }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_frac.svg` } alt="" /></Button></td>
            <td><Button latex="\frac{}{}" cursor="<;<;<" onClick={ props.onEditableViewer }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_mfrac.svg` } alt="" /></Button></td>
            <td><Button latex="\times" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_time.svg` } alt="" /></Button></td>
            <td><Button latex="=" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_equal.svg` } alt="" /></Button></td>
          </tr>
          <tr>
            <td><Button latex="1" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_1.svg` } alt="" /></Button></td>
            <td><Button latex="2" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_2.svg` } alt="" /></Button></td>
            <td><Button latex="3" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_3.svg` } alt="" /></Button></td>
            <td className="l_gray"><Button latex="<" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lessthan.svg` } alt="" /></Button></td>
          </tr>
          <tr>
            <td><Button latex="4" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_4.svg` } alt="" /></Button></td>
            <td><Button latex="5" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_5.svg` } alt="" /></Button></td>
            <td><Button latex="6" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_6.svg` } alt="" /></Button></td>
            <td className="l_gray"><Button latex=">" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_morethan.svg` } alt="" /></Button></td>
          </tr>
          <tr>
            <td><Button latex="7" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_7.svg` } alt="" /></Button></td>
            <td><Button latex="8" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_8.svg` } alt="" /></Button></td>
            <td><Button latex="9" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_9.svg` } alt="" /></Button></td>
            <td className="l_gray"><Button latex="x" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_x.svg` } alt="" /></Button></td>
          </tr>
          <tr>
            <td colSpan="2"><Button latex="0" onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_0.svg` } alt="" /></Button></td>
            <td><Button latex="." onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_comma.svg` } alt="" /></Button></td>
            <td className="d_gray"><Button latex={ TYPE.KEY_STROKE.BACKSPACE } onClick={ props.onKey }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_backspace.svg` } alt="" /></Button></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div className="lower_area">{ props.children }</div>
    </div>
  );

};

export default Landscape;
